export const getters = (state) => ({
  getSortCounter() {
    return state.centralHeatings.table.counter;
  },
});
